export const environment = {
	production: false,
	mapbox: {
		accessToken:
		// "pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY2tjNm5xN3FxMGV3NDJ3bGo5cGFsYmczayJ9.ALvXknS_cII7yVAEw6U19Q",
			"pk.eyJ1IjoiZnJvbnRwb3IiLCJhIjoiY201djc1amtpMDRmMTJqcTJncmp5MDJpcSJ9.tkEPllsDpMMSR97Vn1oxzQ", // Your access token goes here
	},
	// We can create other properties for any other tokens we need
};
